import { useMemo } from "react";
import { useParams } from "react-router-dom";
import type { ClientRole } from "../types";
import { useMyClients } from "./use-clients";

export const useHasRole = (role: ClientRole) => {
  const { company: clientId } = useParams<{ company: string }>();
  const { data: clients = [] } = useMyClients();
  const currentMembership = useMemo(() => {
    return clients.find((c) => c.client.id === clientId)?.membership;
  }, [clients, clientId]);

  const hasRole =
    currentMembership?.role === "OWNER" || currentMembership?.role === role; // TODO: change me for a permission based system

  return hasRole;
};
